<template lang="pug">
.d-flex.align-center.gap-2
  hq-warehouse-dropdown(ref="warehouseDropdown" v-model="warehouseFilter" :size="size")
  hq-branch-dropdown(ref="branchDropdown" v-model="branchFilter" :size="size")
</template>

<script>
import HqWarehouseDropdown from './HqWarehouseDropdown.vue'
import HqBranchDropdown from './HqBranchDropdown.vue'

export default {
  components: { HqWarehouseDropdown, HqBranchDropdown },
  props: {
    value: { default: null },
    size: { type: String, default: 'lg' }
  },
  data () {
    return {
      warehouseFilter: null,
      branchFilter: null
    }
  },
  watch: {
    warehouseFilter () {
      this.emitResolved()
    },
    branchFilter () {
      this.emitResolved()
    },
    value (val) {
      if (val === null) {
        this.warehouseFilter = null
        this.branchFilter = null
      }
    }
  },
  methods: {
    emitResolved () {
      const wAll = this.warehouseFilter === null
      const bAll = this.branchFilter === null

      if (wAll && bAll) {
        this.$emit('input', null)
        return
      }

      const warehouseItems = wAll ? (this.$refs.warehouseDropdown?.allItems || []) : this.warehouseFilter
      const branchItems = bAll ? (this.$refs.branchDropdown?.allItems || []) : this.branchFilter

      const ids = [...warehouseItems, ...branchItems].map(item => item.id)
      this.$emit('input', ids.length ? ids : null)
    }
  }
}
</script>
